<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <RouteBreadCrumb />
          </nav>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" lg="6" align="left">
          <h3 class="text-white">{{ operator.name }}</h3>
          <p class="text-white" v-html="operator.description" />
        </b-col>
        <b-col xs="12" lg="6" align="right">
          
          <router-link :to="editLink" v-if="isAdmin"><base-button :to="editLink" v-if="isAdmin" type="secondary" size="sm" class="btn-secondary--alt">Edit Operator</base-button></router-link>
          <base-button @click="handleDelete" v-if="isAdmin" type="warning" size="sm" class="edit" icon><i class="far fa-trash-alt"></i></base-button>

        </b-col>
      </b-row>
    </base-header>

    <RecipeList :searchUri="'recipes/searchRecipes'" :binder="this.$store.state.recipes.all" :payload="{ 'operatorId': this.$route.params.id }" />
  
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import RecipeList from '@/views/Recipe/RecipeList.vue';
  import swal from 'sweetalert2'

  export default {
    components: {
      RouteBreadCrumb,
      RecipeList,
      swal
    },
    data() {
      return {
        propsToSearch: ['name', 'description', 'operator'],
        data: null,
        itemLimit: '10',
        editLink: ''
      };
    },
    computed: {
      operator() {
        return this.$store.state.operators.current;
      },
      isAdmin() {
       return this.$store.getters.userIsAdmin
      },
    },
    methods: {
      handleDelete() {
        swal.fire({
          title: 'Are you sure?',
          text: `You won't be able to revert this!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            const { dispatch } = this.$store;
            dispatch("operators/deleteOperator", this.operator.id);
            this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Operator Deleted'});
            this.$router.push({path: "/operators"});
          }
        });
      }
    },
    created() {
      this.editLink = `/operator/edit-operator/${this.$route.params.id}`;
      const { dispatch } = this.$store;
      dispatch("operators/getById",this.$route.params.id);
    }
  };
</script>
<style>
</style>